import { CalendarTimezoneData } from "@/common/types/calendarTimezone.type";
import { CompanyData } from "@/common/types/companies/companies.type";
import { File } from "@/common/types/file";
import { GeneralInformationData } from "@/common/types/generalInformation.type";
import { ProductData } from "@/common/types/product.type";
import { EstablishmentCompanyData } from "@/features/company/types/company.type";

export enum BillStatusEnum {
  InProcess = 'in_process',
  PendingPayment = 'pending_payment',
  Paid = 'paid',
  PartiallyPaid = 'partially_paid',
  WithIntegrationFailure = 'with_integration_failure',
  AwaitingPaymentConfirmation = 'awaiting_payment_confirmation',
  ProcessingPayment = 'processing_payment',
  PaymentNotNeeded = 'payment_not_needed',
  PendingSupplyAuthorization = 'pending_supply_authorization',
  AwaitingManualApproval = 'awaiting_manual_approval',
  RejectedByCompany = 'rejected_by_company',
}

export type BillData = {
  id: string;
  status: string;
  closed_at: string;
  due_at: string;
  opened_at: string;
  created_at: string;
  protocol_number: string;
  total_amount: string | number;
  events_count: number;
  grouping_mode: string;
  sub_groupable_klass: string;
  granted_credit: string | number;
  groupable: ProductData;
  number?: string;
  kind?: string;
  time_zone: CalendarTimezoneData;
  client_branch: {
    display_name: string;
    id: string;
    parent_id: string;
    general_information?: GeneralInformationData;
  };
  rejected_by_company_at: string | null
};

export type BillResumeData = {
  number?: string;
  accepted_by_service_at?: string;
  accepted_reissue_by_service_at?: string;
  client_branch: {
    id: string;
    display_name: string;
    parent_id: string;
  };
  client_company?: CompanyData;
  closed_at?: string;
  created_at?: string;
  csv?: File;
  due_at?: string;
  establishment_company?: EstablishmentCompanyData;
  id?: string;
  kind?: 'consumption' | 'service' | 'payment' | 'informational_only';
  movements_totalizer?: {
    consumed_total: string;
    discount_total: string;
    fees_total: string;
    transfered_total: string;
    transfered_fees_total_with_discounts: string;
    profitability: string;
    product_movements: {
      movements_count: number;
      movement_total_sum: string;
      product_quantity_sum: string;
      product_price_avg: string;
      refunded_movements_count: number;
      refunded_movement_total_sum: string;
      product_display_name: string;
      net_product_quantity_sum: string;
    }[];
    fees: {
      movements_count: number;
      movement_total_sum: string;
      refunded_movements_count: number;
      refunded_movement_total_sum: string;
      fee_display_name: string;
      source_name: string | null;
    }[];
  };
  need_supply_authorization: boolean;
  opened_at?: string;
  overdue_at?: string;
  paid_at?: string;
  pdf?: File;
  profitability?: string;
  reports?: (File & { filename: string })[];  status?: BillStatusEnum;
  total_amount?: string;
  collected_fiscal_documents_zip: {
    attachment_id: string;
    content_type: string;
    id: string;
    url: string;
  }
  time_zone: CalendarTimezoneData;
  rejected_by_company_reason: string | null;
};

export type BillResponse = {
  data: {
    data: BillData;
  };
};

export type BillResumeResponse = {
  data: {
    data: BillResumeData;
  };
};
